import { createFetch } from '@convergence/client';
import { API_ENDPOINT } from '../lib/api';

export const fetch = createFetch(API_ENDPOINT);
